import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Alert, AlertService } from '@michelin/theme';
import { StateDto } from 'src/app/shared/models/location/state-dto';
import { ProductLineDto } from 'src/app/shared/models/product-line/product-line-dto';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { AutomakerFormComponent } from '../components/automaker-form/automaker-form.component';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';
import { LocationService } from 'src/app/shared/services/location/location.service';
import { ProductLineService } from 'src/app/shared/services/product-line/product-line.service';

@Component({
    selector: 'app-update-automaker',
    templateUrl: './update-automaker.component.html',
    standalone: false
})
export class UpdateAutomakerComponent implements OnInit {
  loading: boolean = false;
  automakerId: number = 0;

  data = {
    states: [] as StateDto[],
    productLines: [] as ProductLineDto[],
    automaker: {} as AutomakerDto
  };

  @ViewChild(AutomakerFormComponent) automakerForm: AutomakerFormComponent;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly alertService: AlertService,
    private readonly automakerService: AutomakerService,
    private readonly locationService: LocationService,
    private readonly productLineService: ProductLineService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.automakerId = this.activatedRoute.snapshot.params['id'];

    forkJoin({
      states: this.locationService.findAllStates(),
      productLines: this.productLineService.findAll(),
      automaker: this.automakerService.findById(this.automakerId)
    })
      .subscribe({
        next: (result) => (this.data = result),
        complete: () => this.automakerForm.loadFormValues(this.data.automaker)
      })
      .add(() => (this.loading = false));
  }

  submitForm() {
    this.loading = true;
    this.automakerService
      .update(this.automakerId, this.automakerForm.formValues)
      .subscribe({
        next: () =>
          this.alertService.showAlert({
            type: 'success',
            content: 'Montadora atualizada com sucesso'
          } as Alert),
        error: () => {
          this.alertService.showAlert({
            type: 'critical',
            content: 'Ocorreu um erro ao atualizar a Montadora'
          } as Alert);
        }
      })
      .add(() => (this.loading = false));
  }
}
